<template>
  <div>
    <div class="content__filter">
      <div v-if="page.in_sections && Object.keys(page.in_sections).length  || page.sections && Object.keys(page.sections).length" class="search__filter">
        <div v-if="Object.keys(page.in_sections).length && page.in_sections"
             class="search__filter-box search__filter-box_type_toggle">
          <div class="search__filter-box-title">
            в названиях разделов
          </div>
          <div class="search__filter-box-nav">
            <span class="search__filter-box-nav-current"></span>

            <ul class="search__filter-box-nav-list">
              <li v-for="(value, name, index) in page.in_sections"
                  :key="index"
                  class="search__filter-box-nav-item">
                <a :href="'/catalog/' + name + '/'"
                   class="search__filter-box-nav-link"
                   :class="{'hide': index >= maxSection && !isShowMoreInSections}">
                  {{ value }}
                </a>
              </li>
            </ul>
          </div>

          <div v-if="Object.keys(page.sections).length > maxSection && !isShowMoreInSections" @click="showInSection"
               class="search__filter-box-toggler">Все разделы
          </div>
        </div>
        <div v-if="Object.keys(page.sections).length && page.sections"
             class="search__filter-box search__filter-box_type_toggle">
          <div class="search__filter-box-title">
            в разделах каталога
          </div>
          <div class="search__filter-box-nav">
            <span class="search__filter-box-nav-current"></span>

            <ul class="search__filter-box-nav-list">
              <li v-for="(value, name, index) in page.sections"
                  :key="index"
                  class="search__filter-box-nav-item">
                <a :href="'/catalog/' + name + '/?q=' + encodeURI($route.query.q)"
                   class="search__filter-box-nav-link"
                   :class="{'hide': index >= maxSection && !isShowMoreSections}">
                  {{ value }}
                </a>
              </li>
            </ul>
          </div>

          <div v-if="Object.keys(page.sections).length > maxSection && !isShowMoreSections" @click="showSection"
               class="search__filter-box-toggler">Все разделы
          </div>
        </div>
      </div>

      <div class="catalog__header">
        <div class="filter">
          <FilterBox></FilterBox>
          <div class="filter__hint-result">Найдено
            <span class="data-length-span">{{ page.cnt }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="content__main">
      <notifications :group="groupNotify"
                     :closeOnClick="false"
                     :width="500"
                     :max="5"
                     animation-name="v-fade-left"
                     position="top left">
        <template v-slot:body="props">
          <div class="custom-template">
            <div class="custom-template-icon">
              <a target="_blank" :href="props.item.data.url" class="link">
                <img :src="props.item.data.images.small.length ? props.item.data.images.small[0] : '/upload/empty/58.png'" width="58">
              </a>
            </div>
            <div class="custom-template-content">
              <div class="custom-template-title">
                {{props.item.title}}
              </div>
              <div class="custom-template-text"
                   v-html="props.item.text"></div>
            </div>
            <div class="custom-template-close"
                 @click="close(props.item.data.id)">
              <i class="icon icon-close"></i>
            </div>
          </div>
        </template>
      </notifications>
      <h1>{{ page.name }}</h1>

      <breadcrumbs v-if="$route.path != '/search/'" :items="page.breadcrumbs" :name="page.name"></breadcrumbs>

      <modal-element
          v-show="isModalVisible"
          @close="closeModal"
          :item="item"
          :user="page.user"
          :cart="cart[item.id]"
      />

      <modal-sertificate
          v-if="isModalSertificateVisible"
          @close="closeModalSertificate"
          :item="item"
      />

      <modal-youtube
          v-if="isModalYoutubeVisible"
          @close="closeModalYoutube"
          :item="item"
      />

      <modal-images
          v-show="isModalImagesVisible"
          @close="closeModalImages"
          :item="item"
      />

      <div class="search__container">
        <div class="search__results-list">
          <SubmenuTree></SubmenuTree>

          <div class="catalog__controls pure-g">
            <div class="pure-u-md-7-24  xs-hide">
              <div class="catalog__controls-page_view catalog__header-col catalog__header-col_inline">
                <div class="catalog__view-template view-template xs-hide">
                  <button @click="changePageView('list')" data-attr-view="list"
                          class="view-template__button" :class="{'active': viewMode == 'list'}">
                    <span class="view-template__button-icon icon icon-list"></span>
                  </button>
                  <button @click="changePageView('box')" data-attr-view="box"
                          class="view-template__button" :class="{'active': viewMode == 'box'}">
                    <span class="view-template__button-icon icon icon-grid"></span>
                  </button>
                </div>
              </div>
            </div>
            <div class="pure-u-2-3 pure-u-md-10-24">
              <SortBox></SortBox>
            </div>
            <div class="pure-u-1-3 pure-u-md-7-24 ">
              <div class="catalog__controls-per_page catalog__header-col">
                <div class="sort catalog__sort sml-hide">
                  <span class="sort__caption xs-hide">Показывать по:</span>
                  <a v-for="(index) in arPerPage"
                     href="#"
                     @click.prevent="setOnPage(index)"
                     :key="index"
                     class="sort__parametr"
                     :class="{'active': index == perPage}">{{ index }}</a>
                </div>
              </div>
            </div>
          </div>


          <Pagination></Pagination>

          <div class="catalog">
            <div class="catalog__list">
              <template v-if="isLoading">
                <div class="loader"></div>
              </template>
              <template v-else-if="page.cnt > 0">
                  <div v-for="item in page.items"
                     :key="item.id"
                     class="product"
                     :class="{'product_view_list': viewMode =='list', 'product_view_box': viewMode =='box'}">
                  <div class="product__content-inner">
                    <div class="product__picture">
                      <div class="product__badges" v-if="item.badge.length > 0">
                        <span class="product__badge" v-if="item.badge.includes('hit')">Хит</span>
                        <span class="product__badge" v-if="item.badge.includes('new')">Новинка</span>
                        <span class="product__badge" v-if="item.badge.includes('action')">Акция</span>
                      </div>
                      <div class="slider-product-image product__picture-slider">
                        <template v-if="item.images.small.length > 0">
                          <vue-swiper :images="item.images.small" :key="item.id" :item-id="item.id" :isZoom="false"></vue-swiper>
                        </template>
                        <template v-else>
                          <div class="thumb-image img-content">
                            <img src="/img/empty-300.png">
                          </div>
                        </template>
                      </div>
                      <div class="product__bottom-badges" v-if="item.badge.length > 0">
                        <span class="product__badge" v-if="item.badge.includes('pack_damaged')">Повреждена упаковка</span>
                      </div>
                      <div class="product__to_favorite" @click="toFavorite(item)">
                        <span class="icon"
                              :class="{'icon-heart': !item.favorite, 'icon-heart-full': item.favorite}"></span>
                      </div>
                    </div>
                    <div class="product__main-info">
                      <div class="product__options-info">
                        <span class="product__options-info-item">Код:
                          <vue-popper :id="item.id + '-xmlid'"
                                      :hint="'Копировать'" :hint-click="'Скопировано'" @hinted="copy">{{ item.code }}</vue-popper>
                        </span>
                        <span class="product__options-info-item">Артикул:
                          <vue-popper :id="item.id + '-vendorCode'"
                                      :hint="'Копировать'" :hint-click="'Скопировано'" @hinted="copy">{{ item.vendorCode }}</vue-popper>
                        </span>
                        <span class="product__options-info-item">Штрих-код:
                          <vue-popper :id="item.id + '-barcode'"
                                      :hint="'Копировать'" :hint-click="'Скопировано'" @hinted="copy">{{ item.barcode }}</vue-popper>
                        </span>
                      </div>
                      <a :href="item.url"
                         @click.prevent="showModal(item)"
                         :element-url="item.url"
                         :element-id="item.id"
                         :section-id="item.section_id"
                         class="product__name element-view-button">
                        {{ item.name }}
                      </a>
                      <product-statuses :item="item" v-if="page.user.isAuthorized"></product-statuses>
                      <ul class="product__options">
                        <li class="product__options-item" v-if="item.dimensions.size">
                          <span class="product__options-item-caption">Размер(ШхВxГ)</span>
                          <span class="product__options-item-value">{{ item.dimensions.size }} см</span>
                        </li>
                        <template v-for="(pval, pkey) in item.properties">
                          <li v-if="pval.code=='TorgovayaMarka' || pval.code=='Litsenziya'"
                              class="product__options-item">
                            <span class="product__options-item-caption">{{ pkey }}</span>
                            <span class="product__options-item-value">
                              <a :href="pval.url" target="_blank">{{ pval.text }}</a>
                            </span>
                          </li>
                        </template>

                        <li v-if="item.licenses.length > 0" class="product__options-item">
                          <span class="product__options-item-caption">Лицензии</span>
                          <span class="product__options-item-value" style="display: grid;">
                            <a v-for="(lval, lkey) in item.licenses" :href="lval.url" target="_blank">{{ lval.text }}</a>
                          </span>
                        </li>

                        <!--<li class="product__options-item">
                          <span class="product__options-item-caption">Дата прихода</span>
                          <span class="product__options-item-value">{{ item.arrivalDate }}</span>
                        </li>-->
                      </ul>
                      <div class="product__action-link product__action-link_sertificat popup-image-gallery"
                           style="float: left; margin-right: 20px;" v-if="item.certificates.length > 0">
                        <a :href="'/upload/cert/' + item.certificates[0]" @click.prevent="showModalSertificate(item)"
                           class="product__action-link-text">
                          <span class="product__action-link-icon icon icon-sertificat"></span>
                          Сертификат
                        </a>
                      </div>
                      <div class="product__action-link product__action-link_sertificat popup-image-gallery"
                           v-if="item.youtube_id" style="position: unset;">
                       <!-- <a target="_blank" :href="'https://www.youtube.com/watch?v=' + item.youtube_id"
                           class="popup-video product__picture-slider-thumbs-other-actions-item product__picture-slider-thumbs-other-actions-item_video" title="Видео">
                          <img src="/img/youtube.png" style="height: 25px;">
                        </a> -->
                        <a target="_blank"  @click.prevent="showYoutube(item)"
                           class="popup-video product__picture-slider-thumbs-other-actions-item product__picture-slider-thumbs-other-actions-item_video" title="Видео">
                          <img src="/img/youtube.png" style="height: 25px;">
                        </a>
                      </div>
                      <div class="product__action-link product__action-link_sertificat popup-image-gallery"
                           v-if="item.manual" style="position: unset;">
                        <a target="_blank" :href="'/upload/manuals/' + item.vendorCode + '.pdf'"
                           class="popup-video product__picture-slider-thumbs-other-actions-item product__picture-slider-thumbs-other-actions-item_video" title="Инструкция">
                          <img src="/img/pdf.png" style="height: 25px;">
                        </a>
                      </div>
                    </div>
                    <div class="product__actions" v-if="!item.is_archive">

                      <div class="product__noreg-box" v-if="page.user.isAuthorized">
                        <div class="product__prices">
                          <div class="product__price product__price_type_old" v-if="item.price.stock != item.price.price">
                            {{ Math.round(item.price.stock * item.step * 100) / 100  }} Р.
                            <span class="percent-badge percent-badge_theme_yellow percent-badge_size_xs product__price-percent"
                                v-if="item.price.type=='MANUAL'">
                              <span class="percent-badge__value">
                                <vue-popper :id="item.id + '-el-percent'"
                                            :hint="'Ваша перональная скидка на данную категорию товаров'">{{
                                    item.price.percent
                                  }}</vue-popper>
                              </span>
                            </span>
                            <span
                                class="percent-badge percent-badge_theme_red percent-badge_size_xs product__price-percent"
                                v-else>
                              <span class="percent-badge__value">{{ item.price.percent }}</span>
                            </span>
                          </div>
                          <div class="product__price">
                            {{ Math.round(item.price.price * item.step * 100) / 100  }} Р.
                          </div>
                        </div>

                        <product-summary-controls :item="item" :cartCount="cart[item.id]" :productId="item.id" :v="item.dimensions.volume" :x="item.code"></product-summary-controls>

                      </div>
                      <div v-else>
                        <div class="product__noreg-box-text">
                          Видеть цены и покупать могут только зарегистрированные пользователи
                        </div>
                        <a :href="'/auth/?login=yes&backurl=' + back_url"
                           class="product__noreg-box-button button button_theme_primary_blue button_size_md">
                          <span class="button__text">Войти и купить</span>
                        </a>
                        <a :href="'/auth/?register=yes&backurl=' + back_url">Зарегистрироваться</a>
                      </div>


                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="search">
                  <h1 class="content__page-title">
                    По Вашему запросу ничего не найдено
                  </h1>

                  <div class="content__page-description-text">
                    <p v-if="$route.path == '/search_archive/'">
                      Советуем изменить поисковый запрос
                    </p>
                    <p v-else>
                      <template v-if="page.altQuery">
                        Возможно вы искали "<a :href="'/search/?q=' + encodeURI(page.altQuery)">{{ page.altQuery }}</a>"?
                      </template>
                      <template>
                        Также советуем изменить запрос или поискать в <a
                          :href="'/search_archive/?q=' + encodeURI($route.query.q)">архиве</a>
                      </template>
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <Pagination></Pagination>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilterBox from "./FilterBox.vue";
import SortBox from "./SortBox.vue";
import Pagination from './Pagination.vue'
import SubmenuTree from "./SubmenuTree.vue";
import ModalElement from "./ModalElement.vue";
import ModalSertificate from "./ModalSertificate.vue";
import ModalYoutube from "./ModalYoutube.vue";
import ModalImages from "./ModalImages.vue";
import Breadcrumbs from "./Breadcrumbs.vue"
import eventBus from "./EventBus.vue";
import VueSwiper from "./VueSwiper.vue";
import VuePopper from "./VuePopper.vue";
import ProductStatuses from "./ProductStatuses.vue";
import axios from "axios";
import ProductSummaryControls from './ProductSummaryControls.vue';

export default {
  data: function () {
    return {
      arPerPage: [20, 50, 100],
      perPage: 0,
      isModalVisible: false,
      isModalSertificateVisible: false,
      isModalYoutubeVisible: false,
      isModalImagesVisible: false,
      isLoading: false,
      isShowMoreSections: false,
      isShowMoreInSections: false,
      item: {},
      viewMode: $cookies.get("viewMode") ? $cookies.get("viewMode") : 'list',
      maxSection: 7,
      back_url: window.btoa(this.$route.path),
      basket: this.$ls.get('basket'),
      notifyIds: [],
      groupNotify: 'custom-template'
    }
  },
  computed: {
    page() {
      return this.$store.getters.page;
    },
    cart() {
      let result = {};

      if ('items' in this.$store.getters.page && this.$store.getters.page.items.length > 0) {
        let vm = this;
        vm.basket = this.$ls.get('basket');
        this.$store.getters.page.items.forEach(function (item) {
          result[item.id] = 0;
          if ('items' in vm.basket && vm.basket.items.length > 0) {
            vm.basket.items.forEach(function (basketItem) {
              if (item.id == basketItem.productId)
                result[item.id] = basketItem.quantity;
            });
          }
        });
      }

      return result;
    }
  },
  watch: {
    page(val) {
      this.perPage = val.page.perPage;
      this.isLoading = false;

      if(this.page.cnt > 0 && !this.page.items
              || this.page.cnt > 0 && this.page.items.length <= 0){
          ym(YANDEX_COUNTER_ID, 'reachGoal', 'CATALOG_EMPTY');
      }

    }
  },
  created() {
    let vm = this;
    this.isLoading = true;
    eventBus.$on('updateFavorite', function (data) {
      vm.toFavorite(data.item);
    });
    eventBus.$on('sendModal', function (data) {
      let selectedItem = null;
      vm.page.items.forEach(function (item) {
        if (data.id === item.id)
          selectedItem = item;
      });
      if (selectedItem != null)
        vm.showModalImages(selectedItem);
    });
    eventBus.$on('showSertificate', function (data) {
      vm.showModalSertificate(data.item);
    });
    eventBus.$on('showYoutube', function (data) {
      vm.showYoutube(data.item);
    });
  },
  mounted() {
    if (!$cookies.get("isShowSubMenuTree")) {
      const el = document.querySelector('.catalog__sort');
      el.scrollIntoView({block: "start", inline: "center", behavior: "smooth"});
    }
  },
  methods: {
    drawNotify: function (item, result) {
      let id = item.id;
      if (this.page.user.isAuthorized) {
        if (this.notifyIds.length > 0) {
          this.notifyIds.forEach(notifyId => {
            if (notifyId == id)
              this.$notify.close(id);
          })
        }

        let message = result.message;
        if (result.type == 'change')
          message = message + ' на ' + result.result.quantity + '.';

        if (result.type == 'add')
          message = message + ' в количестве ' + result.result.quantity + '.';

        this.$notify({
          id,
          group: this.groupNotify,
          title: message + '. Вы будете уведомлены по поступлению товара на склад.',
          text: item.name,
          type: '',
          duration: 4000,
          speed: 0,
          data: item
        });
        this.notifyIds.push(id);
      }
    },
    close: function (id) {
      this.$notify.close(id);
    },
    toFavorite: function(item) {
      if (item.favorite > 0) {
        axios.post(
            '/api/favorite/delete',
            {
              'id': item.favorite
            },
            {
              headers: {
                'content-type': 'application/json; charset=utf8',
                'X-Requested-With': 'XMLHttpRequest',
              },
            }
        )
            .then(function (response) {
              if (response.data.status)
                item.favorite = response.data.result;
            })
            .catch(function (error) {
              console.log(error);
            });
      } else {
        axios.post(
            '/api/favorite/add',
            {
              'code': item.code
            },
            {
              headers: {
                'content-type': 'application/json; charset=utf8',
                'X-Requested-With': 'XMLHttpRequest',
              },
            }
        )
            .then(function (response) {
              if (response.data.status)
                item.favorite = response.data.result;
            })
            .catch(function (error) {
              console.log(error);
            });
      }
    },

    showSection: function () {
      this.isShowMoreSections = true;
    },
    showInSection: function () {
      this.isShowMoreInSections = true;
    },

    setOnPage: function (perPage) {
      this.$store.dispatch('SET_SETTINGS', {page: {current: 1, perPage: perPage}});
      this.$store.dispatch('UPDATE_STORE');

      this.$cookies.set("perPage", perPage);
    },
    showModal(item) {
      this.isModalVisible = true;
      this.item = item;
    },
    closeModal(event) {
      if (event && event.target.className == 'modal-wrapper' || event == undefined)
        this.isModalVisible = false;
      else
        return;
    },
    showModalSertificate(item) {
      this.isModalSertificateVisible = true;
      this.item = item;
    },
    showYoutube(item) {
      this.isModalYoutubeVisible = true;
      this.item = item;
    },
    closeModalSertificate(event) {
      if (event && event.target.className == 'modal-wrapper' || event == undefined)
        this.isModalSertificateVisible = false;
      else
        return;
    },
    closeModalYoutube(event) {
      if (event && event.target.className == 'modal-wrapper' || event == undefined)
        this.isModalYoutubeVisible = false;
      else
        return;
    },
    showModalImages(item) {
      this.isModalImagesVisible = true;
      this.item = item;
    },
    closeModalImages(event) {
      if (event && event.target.className == 'modal-wrapper' || event == undefined)
        this.isModalImagesVisible = false;
      else
        return;
    },
    changePageView: function (pageView) {
      this.viewMode = pageView;

      this.$cookies.set("viewMode", this.viewMode);
    },
    selectText: function(element) {
      let range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    copy: function (event) {
      if (navigator.clipboard != undefined) {
        let value = event.target.innerHTML;
        navigator.clipboard.writeText(value)
      } else {
        this.selectText(event.target);
        document.execCommand("copy");
      }
    },
  },
  components: {
    VueSwiper,
    VuePopper,
    SubmenuTree,
    Pagination,
    FilterBox,
    SortBox,
    ModalElement,
    ModalSertificate,
    ModalYoutube,
    ModalImages,
    Breadcrumbs,
    ProductStatuses,
    ProductSummaryControls
  }

}
</script>


<style scoped>

</style>